"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCloudSunOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M18 1h2v3h-2zM10.517 4.93l1.403-1.426 2.138 2.104-1.403 1.426zM27 11h3v2h-3zM23.965 5.652l2.105-2.138 1.425 1.403-2.104 2.138zM19 6a6 6 0 00-5.62 4h.09a10.11 10.11 0 012 .22A4 4 0 1122 14.58a6.61 6.61 0 01.37.55 8.83 8.83 0 011.27.63A6 6 0 0019 6zM20.27 17.61A7.23 7.23 0 0013.5 13a7 7 0 00-6.94 6.08A5.5 5.5 0 007.5 30h11.25A6.25 6.25 0 0025 23.75a6 6 0 00-4.73-6.14zM18.75 28H7.5a3.5 3.5 0 010-7h1v-1a5 5 0 015-5 5.16 5.16 0 015 3.74l.17.68.69.07A3.94 3.94 0 0123 23.75 4.26 4.26 0 0118.75 28z" })));
}
exports.default = SvgCloudSunOutline;
//# sourceMappingURL=CloudSunOutline.js.map